import { Api } from "../api/api";

export const downloadFile = async (url: string): Promise<void> => {
  const res = await Api.get<Blob>(url, { responseType: "blob" });

  const cd = res.headers["content-disposition"];
  if (!cd) throw new Error("Missing Content-Disposition header");

  const filename = getFilenameFromContentDisposition(cd);

  const blob = res.data;
  const href = URL.createObjectURL(blob);

  const a = document.createElement("a");
  a.href = href;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();

  setTimeout(() => URL.revokeObjectURL(href), 0);
};

const getFilenameFromContentDisposition = (header: string): string => {
  // handles both filename="..." and RFC5987 filename*=UTF-8''...
  const star = header.match(/filename\*\s*=\s*(?:UTF-8''|)([^;]+)/i);
  if (star?.[1]) return decodeURIComponent(star[1].replace(/"/g, ""));

  const plain = header.match(/filename\s*=\s*([^;]+)/i);
  if (plain?.[1]) return plain[1].replace(/"/g, "").trim();

  return "download"; // fallback if no filename found
};
